import React from 'react';
import { IProps, IState, FormActionsEnum } from './types';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import MemberProfileForm from 'components/MemberProfileForm';
import { MemberProfileTitle } from 'constants/enums/memberProfileTitle.enum';
import { MemberProfile } from 'bff/models/member';
import service from 'bff/services/memberMaintainService';
// import memberProfileService from 'bff/services/memberProfileService';
import apiCommonService from 'bff/services/commonService';
import { MemberMaintainStep } from 'constants/enums/memberMaintainStep.enum';
import { OTPInfo, LogInInfo } from 'bff/models/login';
import OTPVerificationForm from 'components/OTPVerificationForm';
import MaintainComplete from 'components/MaintainComplete';
import { SactionType } from 'constants/enums/sactionType.enum';
import commonService from 'utils/commonService';
import { RouterSettings } from 'constants/models/routerSettings';

class MemberMaintain extends React.Component<IProps, IState> {
  state: IState = {
    secques: [],
    nationalitys: [],
    occupations: [],
    postcodes: [],
    emailDomains: [],
    memberProfile: {
      MEMBER_ID: '',
      GENDER: '',
      NAME: '',
      BIRTHDAY: '',
      MOBILE: '',
      EMAIL_ADDR: '',
      HEARING_DISABILITY: '',
      SECQUE_ID: '',
      SECQUE_QUESTION: '',
      SECQUE_ANSWER: '',
      NATIONALITY_ID: '',
      NATIONALITY_TYPE: '',
      MEMBERSHIP: []
    },
    originProfile: {
      MEMBER_ID: '',
      GENDER: '',
      NAME: '',
      BIRTHDAY: '',
      MOBILE: '',
      EMAIL_ADDR: '',
      HEARING_DISABILITY: '',
      SECQUE_ID: '',
      SECQUE_QUESTION: '',
      SECQUE_ANSWER: '',
      NATIONALITY_ID: '',
      NATIONALITY_TYPE: '',
      MEMBERSHIP: []
    },
    memberId: storageService.getItem(storageKeys.MemberId),
    activeStep: MemberMaintainStep.MemberMaintain,
    tipCode: [],
    UICode: [],
    notifyVal: false,
    formAction: null,
    formLockup: true
  }

  componentDidMount = async () => {
    // console.log('this.state.memberId', this.state.memberId);
    const initSettingRes = await service.fetchInitSetting(this.state.memberId);
    // console.log(initSettingRes.memberProfile);
    // console.log('initSettingRes', initSettingRes);
    this.setState({
      secques: [...initSettingRes.secques],
      nationalitys: [...initSettingRes.nationalitys],
      occupations: [...initSettingRes.occupations],
      postcodes: [...initSettingRes.postcodes],
      emailDomains: [...initSettingRes.emailDomains],
      memberProfile: { ...initSettingRes.memberProfile },
      originProfile: { ...initSettingRes.memberProfile },
      tipCode: [...initSettingRes.tipCode],
      UICode: [...initSettingRes.UICode]
    });
  };

  componentDidUpdate () {
    commonService.scrollToTop();
  };

  /**
   * @description 會員維護-編輯方法
   */
  handleEditMemberProfile = async (memberProfile: MemberProfile) => {
    this.setState({ formAction: FormActionsEnum.Edit });
    this.handleEdit();
    // await this.handleFetchOTP(memberProfile);
  };

  /**
   * @description 編輯會員資料
   */
  handleEdit = () => {
    this.setState({ activeStep: MemberMaintainStep.MemberMaintain, formLockup: false });
  };

  /**
   * @description 取消編輯會員資料
   */
  handleCancel = () => {
    this.props.history.go(0);
  };

  /**
   * @description 會員維護-更新方法
   */
  handleUpdateMemberProfile = async (memberProfile: MemberProfile) => {
    let fromLogin = false;

    this.setState({ formAction: FormActionsEnum.Update });

    if (this.props.history.location.state) {
      const { preUrl }: any = this.props.history.location.state;

      if (!preUrl) return;

      fromLogin = preUrl.indexOf('login') !== -1;
    }

    const verifyOTP = !fromLogin && (this.state.originProfile.MOBILE !== memberProfile.MOBILE ||
      this.state.originProfile.EMAIL_ADDR !== memberProfile.EMAIL_ADDR);

    if (verifyOTP) {
      await this.handleFetchOTP(memberProfile);
    } else {
      await this.handleUpdate(this.state.memberId, memberProfile);
    }
  }

  /**
   * @description 更新會員資料
   */
  handleUpdate = async (memberId: string, memberProfile: MemberProfile) => {
    const result = await service.updateMemberProfile(memberId, memberProfile);
    if (result) {
      if (storageService.getItem(storageKeys.LoginInfo)) {
        let loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo)) as LogInInfo;
        loginInfo = {
          ...loginInfo,
          wwu_name: memberProfile.NAME
        };
        storageService.setItem(storageKeys.LoginInfo, JSON.stringify(loginInfo));
      }

      this.setState({ activeStep: MemberMaintainStep.MaintainComplete, notifyVal: false });
    }
  }

  /**
   * @description 取得 OTP 驗證碼方法
   * @param memberProfile 會員基本資料
   * @param isReSent 是否為重新發送
  */
  handleFetchOTP = async (memberProfile: MemberProfile, isReSent?: boolean) => {
    const result = await apiCommonService.fetchOTP(memberProfile, SactionType.Signup, isReSent);
    if (result) {
      this.setState({
        activeStep: MemberMaintainStep.OTPVerification,
        memberProfile: { ...memberProfile },
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime()
      });
    }
  }

  /**
    * @description 驗證 OTP 驗證碼方法
    * @param otpVerificationReq OTP 驗證頁 Request Model
   */
  handleVerifyOTP = async (otpCode: string) => {
    const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Signup, false);

    if (typeof result === 'string') return;

    if (this.state.formAction === FormActionsEnum.Edit) {
      this.handleEdit();
    } else if (this.state.formAction === FormActionsEnum.Update) {
      await this.handleUpdate(this.state.memberId, this.state.memberProfile);
    }
  }

  /**
   * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
   */
  handleReSetProfile = () => {
    this.setState({
      activeStep: MemberMaintainStep.MemberMaintain,
      otpInfo: undefined,
      getOTPTime: undefined,
      notifyVal: true
    });
  };

  handleCompleteSubmit = async () => {
    // 如果路由有狀態，且有記錄前次路由，表為 header 導頁而來，導頁回原本網址
    if (this.props.history.location.state) {
      const { preUrl, originUrl }: any = this.props.history.location.state;
      if (preUrl) {
        const lastIndex = preUrl.lastIndexOf('/');
        const targetUrl = preUrl.substring(lastIndex);

        const path = {
          pathname: `${process.env.REACT_APP_PREFIX}${targetUrl}`,
          state: { originUrl: originUrl }
        };

        this.props.history.push(path);
      }
    } else {
      this.props.history.replace(RouterSettings.Home);
      // const memberProfile = await memberProfileService.fetchMemberProfile(this.state.memberId);
      // if (memberProfile) {
      //   this.setState({ activeStep: MemberMaintainStep.MemberMaintain, notifyVal: false, memberProfile: { ...memberProfile }, originProfile: { ...memberProfile } });
      // }
    }
  }

  render () {
    let activePage;
    switch (this.state.activeStep) {
      case MemberMaintainStep.MaintainComplete:
        activePage = (
          <MaintainComplete onSubmit={this.handleCompleteSubmit} />
        );
        break;
      case MemberMaintainStep.OTPVerification:
        activePage = (
          <OTPVerificationForm
            memberId={this.state.memberId}
            otpInfo={this.state.otpInfo as OTPInfo}
            getOTPTime={this.state.getOTPTime as number}
            UICode={this.state.UICode}
            onUnavailableAuth={this.handleReSetProfile}
            onGoBack={this.handleReSetProfile}
            onSubmit={this.handleVerifyOTP}
            onResentOTP={() => this.handleFetchOTP(this.state.memberProfile, true)}
          />
        );
        break;
      case MemberMaintainStep.MemberMaintain:
      default:
        if (this.state.memberProfile) {
          activePage = (
            <MemberProfileForm
              memberMaintain
              isFromLogin={this.props.location.state as boolean}
              title={MemberProfileTitle.Maintain}
              secques={this.state.secques}
              nationalitys={this.state.nationalitys}
              occupations={this.state.occupations}
              postcodes={this.state.postcodes}
              emailDomains={this.state.emailDomains}
              memberProfile={this.state.memberProfile}
              tipCode={this.state.tipCode}
              UICode={this.state.UICode}
              onGoBack={() => this.props.history.goBack()}
              onFormSubmit={this.handleUpdateMemberProfile}
              notifyVal={this.state.notifyVal}
              editBtnVisible={this.state.formLockup}
              onFormEdit={this.handleEditMemberProfile}
              formLockup={this.state.formLockup}
              onCancel={this.handleCancel}
            />
          );
        }
        break;
    }
    return (
      <>
        {
          this.state.activeStep === MemberMaintainStep.MaintainComplete ? (
            <div className="member-maintain-complete">
              {activePage}
            </div>
          ) : (
            <div className="member-maintain member-maintain--main-theme">
              <div className="template-container">
                <div className="template-content">
                  {activePage}
                </div>
              </div>
            </div>
          )
        }
      </>
    );
  };
};

export default MemberMaintain;
